
import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Inject, Optional, ViewChild } from '@angular/core';
import { Observable } from "rxjs";
import { AsyncPipe, CommonModule } from "@angular/common";
import { SafePipe } from "../../../shared/pipes/safe.pipe";
import { SafeTypes } from "../../../shared/constants/safe-types.enum";
import { CarouselComponent, CarouselModule, OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { CustomDialogComponent } from 'src/app/shared/models/custom-dialog-component.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ui-img-slide',
  templateUrl: './img-slide.component.html',
  styleUrls: ['./img-slide.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    SafePipe,
    AsyncPipe,
    CarouselModule,
  ]
})
export class ImgSlideComponent implements AfterViewInit, CustomDialogComponent<number, any> {
  ngAfterViewInit(): void {
    const data = this.params || this.matDialogData;
    if (data?.link !== undefined) {
      this.owlCar!.to(data.link);
    }
  }

  @ViewChild('owlCar') owlCar: CarouselComponent | undefined;
  public params: any;
  public dialogResult = new EventEmitter<any>();
  public outsideClick$!: Observable<void>;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public matDialogData: any,
    @Optional() public dialogRef: MatDialogRef<ImgSlideComponent>
  ) {}

  // Getter to access data from either DialogService (params) or MatDialog (matDialogData)
  get dialogData() {
    return this.params || this.matDialogData || {};
  }

  // Close method that works with both DialogService and MatDialog
  closeDialog() {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.dialogResult.emit(null);
    }
  }


  public SafeTypes = SafeTypes;
  public selectedImage!: string;
  public customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 600,
    margin: 8,
    navText: ["<div class='slide-prev'></div>", "<div class='slide-next'></div>"],
    nav: true,
    center: true,
    items: 1,
    autoWidth: true
  };

  changeImage(image: string) {
    this.selectedImage = image;
  }

  changedByNav(data: SlidesOutputData) {
    if (data.slides?.length) {
      this.selectedImage = data.slides[0].id;
    }
  }

  getAspectRatioClass(image: {
    width: number;
    height: number;
    aspectRatio: number;
  }): string {
    if (image.aspectRatio < 0.45) {
      return "x-narrow-image";
    } else if (image.aspectRatio < 0.8) {
      return "narrow-image";
    } else if (image.aspectRatio > 1) {
      return "wide-image"; // Very wide images
    } else {
      return "standard-image"; // Normal aspect ratios
    }
  }
}